module.exports = __webpack_public_path__ + "static/media/csv_format_01.9285aff8.csv";